export class TypewriterEffect {
  private element: HTMLElement;
  private text: string = "";
  private index: number = 0;
  private speed: number;
  private cursor: HTMLSpanElement;
  private onComplete?: () => void;
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(element: HTMLElement, speed: number = 30) {
    this.element = element;
    this.speed = speed;

    this.cursor = document.createElement("span");
    this.cursor.className = "typewriter-cursor";
  }

  start(text: string, onComplete?: () => void): void {
    this.stop();
    this.text = text;
    this.index = 0;
    this.onComplete = onComplete;
    this.element.textContent = "";
    this.element.appendChild(this.cursor);
    this.type();
  }

  private type(): void {
    if (this.index < this.text.length) {
      const char = this.text.charAt(this.index);
      this.element.insertBefore(document.createTextNode(char), this.cursor);
      this.index++;
      this.timeoutId = setTimeout(() => this.type(), this.speed);
    } else {
      this.cursor.remove();
      this.onComplete?.();
    }
  }

  skip(): void {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    this.element.textContent = this.text;
    this.cursor.remove();
    this.onComplete?.();
  }

  stop(): void {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    this.element.textContent = "";
    this.cursor.remove();
  }

  displayInstant(text: string): void {
    this.stop();
    this.text = text;
    this.index = text.length;
    this.element.textContent = text;
  }

  getText(): string {
    return this.text;
  }
}
